import { Box, Stack, Tab, Tabs } from "@mui/material";
import { useCallback, useState } from "react";
import { JOB_BENCHMARKING_TAB } from "../../constants";
import { IJobBenchmarking } from "../../interfaces/Job";
import { useLocale } from "../../providers/LocaleProvider";
import CompetenciesResultTab, { CompetenciesResultTabProps } from "./CompetenciesResultTab";
import JobDescriptionResultTab, { JobDescriptionResultTabProps } from "./JobDescriptionResultTab";
import TasksResultTab, { TasksResultTabProps } from "./TasksResultTab";

export interface BenchmarkComparisonResultProps {
  theme: any;
  results?: IJobBenchmarking;
}

const TabContentMap = new Map<
  JOB_BENCHMARKING_TAB,
  | React.ComponentType<JobDescriptionResultTabProps>
  | React.ComponentType<TasksResultTabProps>
  | React.ComponentType<CompetenciesResultTabProps>
>([
  [JOB_BENCHMARKING_TAB.JOB_DESCRIPTION, JobDescriptionResultTab],
  [JOB_BENCHMARKING_TAB.TASKS, TasksResultTab],
  [JOB_BENCHMARKING_TAB.COMPETENCIES, CompetenciesResultTab]
]);

const BenchmarkComparisonResult = ({ theme, results }: BenchmarkComparisonResultProps) => {
  const [activeTab, setActiveTab] = useState(JOB_BENCHMARKING_TAB.JOB_DESCRIPTION);
  const { translate } = useLocale();

  const renderTabContent = useCallback(() => {
    const TabContent = TabContentMap.get(activeTab);

    if (!TabContent) return;

    return <TabContent theme={theme} results={results} />;
  }, [activeTab, theme, results]);

  return (
    <Stack display='flex' flexDirection='column' gap={5} width={"100%"}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          centered={true}
          value={activeTab}
          variant='fullWidth'
          sx={{ width: "100%" }}
          onChange={(_, value) => setActiveTab(value)}
        >
          <Tab
            label={translate("settingsViews.jobBenchmarking.jobDescriptionTab")}
            value={JOB_BENCHMARKING_TAB.JOB_DESCRIPTION}
          />
          <Tab
            label={translate("settingsViews.jobBenchmarking.tasksTab")}
            value={JOB_BENCHMARKING_TAB.TASKS}
          />
          <Tab
            label={translate("settingsViews.jobBenchmarking.competenciesTab")}
            value={JOB_BENCHMARKING_TAB.COMPETENCIES}
          />
        </Tabs>
      </Box>
      {renderTabContent()}
    </Stack>
  );
};

export default BenchmarkComparisonResult;
